export const SUPPORT_POLICY_URL = 'https://www.mongodb.com/support-policy';

export const TS_SKILLS_URL = 'https://learn.mongodb.com/skills?team=ts';
